import { UseMutationOptions } from "@tanstack/react-query";
import { ClientError } from "graphql-request";

import { graphql } from "lib/generated/app-service-gql";
import {
  StreamBidReportMutation,
  StreamBidReportMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const STREAM_BID_REPORT = graphql(`
  mutation StreamBidReport($input: StreamBidReportRequest!) {
    streamBidReport(StreamBidReportRequest: $input) {
      success
      runId
    }
  }
`);

/**
 * Dispatches a streaming run for an existing bid report (qualification or requirement
 * summary) and returns its Hatchet runId. Pair with `trackOrchestrator(bidId, runId)` so
 * `BidOrchestratorStreamProvider` opens the subscription and folds streamed answers,
 * win themes, and qualification summary into the React Query caches as they arrive.
 */
export function useStreamBidReport(
  options?: UseMutationOptions<
    StreamBidReportMutation,
    ClientError,
    StreamBidReportMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(STREAM_BID_REPORT, {
    ...options,
  });
  return { data: data?.streamBidReport, ...rest };
}
